// extracted by mini-css-extract-plugin
export default {"container":"Personal_container__hj4El","h2":"Personal_h2__SGzf4","listContainer":"Personal_listContainer__CUcNJ","list":"Personal_list__HJgEp"};